import { render, staticRenderFns } from "./SesionesEvento.vue?vue&type=template&id=23c6a4fb"
import script from "./SesionesEvento.vue?vue&type=script&lang=js"
export * from "./SesionesEvento.vue?vue&type=script&lang=js"
import style0 from "./SesionesEvento.vue?vue&type=style&index=0&id=23c6a4fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports